<script>
import { config } from '../config'
import { openApp } from '../utils/openApp'

export default {
    name: 'Questions',
    methods: {
        openApple(){
            window.open('https://apps.apple.com/ru/app/myvpn/id6479427630', '_blank');
        },
        openApp
    }
};
</script>

<template>
    <div id="section1" class="container">
        <div class="quest-container">

            <h2 class="title fs-56 text-center mb-24">Как пользоваться</h2>

            <div  class="title fs-24 text-center mb-60">Скачайте приложение и используйте My<span class="orange">Proxy</span> с удовольствием</div>

            <div @click="openApp" 
                 class="button mb-60 orange-hover" 
                 style="cursor: pointer; 
                        display: flex; 
                        justify-content: center; 
                        gap: 40px; 
                        padding: 20px;
                        border: 2px solid #FAA820;">
                <div>
                    <img src="../assets/images/googleplay.png" alt="" style="">
                </div>
                
                <div style="text-align: left;">
                    <h2>Загрузите в</h2>
                    <h2>Google Play</h2>
                </div>
                
                
            </div>
        </div>

        <h2 class="title fs-56 text-center mb-60">Вопросы о My<span class="orange">Proxy</span></h2>
        <div class="quest-container">
            <div class="accordion" id="accordionExample">
                <div class="accordion-item br-24 mb-12">
                    <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button br-24" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            Как я могу поменять тариф?
                        </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show br-bottom" aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body fs-20">
                            На всех тарифах MyProxy трафик неограничен.
                        </div>
                    </div>
                </div>
                <div class="accordion-item br-24 mb-12">
                    <h2 class="accordion-header" id="headingTwo">
                        <button class="accordion-button collapsed br-24" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            Я могу установить ваш Прокси и на ноутбук, и на смартфон?
                        </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse br-bottom" aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body fs-20">
                            Вы можете установить и пользоваться MyProxy на мобильный телефон  Android и IOS. Для ПК и ноутбука версий нет.
                        </div>
                    </div>
                </div>
                <div class="accordion-item br-24">
                    <h2 class="accordion-header" id="headingThree">
                        <button class="accordion-button collapsed br-24" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            Стоимость не зависит от объёма используемого трафика?
                        </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse br-bottom" aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body fs-20">
                            Стоимость не зависит от объёма используемого трафика.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style></style>